import {combineLatest, merge} from 'rxjs';
import {map, scan} from 'rxjs/operators';
import {numUtil} from '@/helper/num';
import {currenciesCache$} from '@/config';
import {wsLogout$} from '@/user/auth-ws';
import {predictProjectMsg$} from '@/raw/predict-project';
import type {ReduceAction} from '@/types';

import PredictProjectMsg = lp.PredictProjectMsg;
import PredictProjectRaw = lp.PredictProjectRaw;

type Cache = Map<string, PredictProjectRaw>;
type Action = ReduceAction<Cache>;

const predictProjectsData$ = predictProjectMsg$.pipe(map((data: PredictProjectMsg) => data.payload));

const action$ = combineLatest([predictProjectsData$, currenciesCache$]).pipe(
  map(([predictProjectsData, currenciesCache]): Action => {
    const items = predictProjectsData.map((predict) => {
      const item = currenciesCache.get(predict.currencyName);
      if (!item) {
        return {...predict, name: '--', balance: '--'};
      }
      const {name, valueScale, valuePrecision} = item;
      return {...predict, name, balance: numUtil.floor(predict.balanceEv, valuePrecision, valueScale)};
    });
    return function (cache: Cache) {
      items.forEach((predict: PredictProjectRaw) => {
        cache.set(predict.currencyName, predict);
      });
      return cache;
    };
  })
);

const reset$ = wsLogout$.pipe(
  map(
    (): ReduceAction<Cache> => (cache: Cache) => {
      cache.clear();
      return cache;
    }
  )
);

export const predictProjectsCache$ = merge<Action[]>(action$, reset$).pipe(
  scan((p: Cache, c: Action) => c(p), new Map<string, PredictProjectRaw>())
);
